var colorOrderList = {
  "Winsor & Newton": [
    {
      "color": "Lemon Yellow Hue",
      "type": "Yellow"
    },
    {
      "color": "Bismuth Yellow",
      "type": "Yellow"
    },
    {
      "color": "Winsor Lemon",
      "type": "Yellow"
    },
    {
      "color": "Cadmium Lemon",
      "type": "Yellow"
    },
    {
      "color": "Cadmium-Free Lemon",
      "type": "Yellow"
    },
    {
      "color": "Winsor Yellow",
      "type": "Yellow"
    },
    {
      "color": "Transparent Yellow",
      "type": "Yellow"
    },
    {
      "color": "Chrome Yellow Hue",
      "type": "Yellow"
    },
    {
      "color": "Cadmium Yellow Pale",
      "type": "Yellow"
    },
    {
      "color": "Cadmium-Free Yellow Pale",
      "type": "Yellow"
    },
    {
      "color": "Cadmium Yellow",
      "type": "Yellow"
    },
    {
      "color": "Cadmium-Free Yellow",
      "type": "Yellow"
    },
    {
      "color": "Indian Yellow",
      "type": "Yellow"
    },
    {
      "color": "Winsor Yellow",
      "type": "Yellow"
    },
    {
      "color": "Winsor Yellow Deep",
      "type": "Yellow"
    },
    {
      "color": "Cadmium Yellow Deep",
      "type": "Yellow"
    },
    {
      "color": "Cadmium-Free Yellow Deep",
      "type": "Yellow"
    },
    {
      "color": "Cadmium Orange",
      "type": "Orange"
    },
    {
      "color": "Cadmium-Free Orange",
      "type": "Orange"
    },
    {
      "color": "Transparent Orange",
      "type": "Orange"
    },
    {
      "color": "Winsor Orange",
      "type": "Orange"
    },
    {
      "color": "Cadmium Scarlet",
      "type": "Red"
    },
    {
      "color": "Cadmium-Free Scarlet",
      "type": "Red"
    },
    {
      "color": "Scarlet Lake",
      "type": "Red"
    },
    {
      "color": "Cadmium Red",
      "type": "Red"
    },
    {
      "color": "Cadmium-Free Red",
      "type": "Red"
    },
    {
      "color": "Winsor Red",
      "type": "Red"
    },
    {
      "color": "Winsor Red Deep",
      "type": "Red"
    },
    {
      "color": "Cadmium Red Deep",
      "type": "Red"
    },
    {
      "color": "Cadmium-Free Red Deep",
      "type": "Red"
    },
    {
      "color": "Pale Rose Blush",
      "type": "Pink"
    },
    {
      "color": "Rose Madder",
      "type": "Pink"
    },
    {
      "color": "Rose Dore",
      "type": "Pink"
    },
    {
      "color": "Bright Red",
      "type": "Pink"
    },
    {
      "color": "Quinacridone Red",
      "type": "Pink"
    },
    {
      "color": "Alizarin Crimson",
      "type": "Pink"
    },
    {
      "color": "Permanent Carmine",
      "type": "Pink"
    },
    {
      "color": "Permanent Alizarin Crimson",
      "type": "Pink"
    },
    {
      "color": "Permanent Rose",
      "type": "Pink"
    },
    {
      "color": "Ruby Madder Alizarin",
      "type": "Pink"
    },
    {
      "color": "Quinacridone Magenta",
      "type": "Pink"
    },
    {
      "color": "Magenta",
      "type": "Pink"
    },
    {
      "color": "Permanent Magents",
      "type": "Pink"
    },
    {
      "color": "Ultramarine Pink",
      "type": "Pink"
    },
    {
      "color": "Purple Madder",
      "type": "Purple"
    },
    {
      "color": "Purple Lake",
      "type": "Purple"
    },
    {
      "color": "Cobalt Violet",
      "type": "Purple"
    },
    {
      "color": "Permanent Mauve",
      "type": "Purple"
    },
    {
      "color": "Mauve Blue Shade",
      "type": "Purple"
    },
    {
      "color": "Winsor Violet (Dioxazine)",
      "type": "Purple"
    },
    {
      "color": "Ultramarine Violet",
      "type": "Purple"
    },
    {
      "color": "French Ultramarine",
      "type": "Blue"
    },
    {
      "color": "Smalt",
      "type": "Blue"
    },
    {
      "color": "Cobalt Blue Deep",
      "type": "Blue"
    },
    {
      "color": "Ultramarine (Green Shade)",
      "type": "Blue"
    },
    {
      "color": "Cobalt Blue",
      "type": "Blue"
    },
    {
      "color": "Indantherene Blue",
      "type": "Blue"
    },
    {
      "color": "Oriental Blue",
      "type": "Blue"
    },
    {
      "color": "Winsor Blue (Red Shade)",
      "type": "Blue"
    },
    {
      "color": "Winsor Blue (Green Shade)",
      "type": "Blue"
    },
    {
      "color": "Prussian Blue",
      "type": "Blue"
    },
    {
      "color": "Cerulean Blue",
      "type": "Blue"
    },
    {
      "color": "Manganese Blue Hue",
      "type": "Blue"
    },
    {
      "color": "Phthalo Turquoise",
      "type": "Blue"
    },
    {
      "color": "Cobalt Turquoise Light",
      "type": "Blue"
    },
    {
      "color": "Cobalt Green",
      "type": "Green"
    },
    {
      "color": "Mineral Green Deep",
      "type": "Green"
    },
    {
      "color": "Cobalt Chromite Green",
      "type": "Green"
    },
    {
      "color": "Chrome Green Deep Hue",
      "type": "Green"
    },
    {
      "color": "Viridian Hue",
      "type": "Green"
    },
    {
      "color": "Winsor Green (Phthalo)",
      "type": "Green"
    },
    {
      "color": "Winsor Green (Yellow Shade)",
      "type": "Green"
    },
    {
      "color": "Permanent Green Deep",
      "type": "Green"
    },
    {
      "color": "Permanent Green",
      "type": "Green"
    },
    {
      "color": "Winsor Emerald",
      "type": "Green"
    },
    {
      "color": "Permanent Green Light",
      "type": "Green"
    },
    {
      "color": "Terre Verte",
      "type": "Green"
    },
    {
      "color": "Oxide of Chromium",
      "type": "Green"
    },
    {
      "color": "Prussian Green",
      "type": "Green"
    },
    {
      "color": "Sap Green",
      "type": "Green"
    },
    {
      "color": "Cadmium Green Pale",
      "type": "Green"
    },
    {
      "color": "Cadmium-Free Green Pale",
      "type": "Green"
    },
    {
      "color": "Green Gold",
      "type": "Green"
    },
    {
      "color": "Olive Green",
      "type": "Green"
    },
    {
      "color": "Naples Yellow Light",
      "type": "Yellow"
    },
    {
      "color": "Naples Yellow",
      "type": "Yellow"
    },
    {
      "color": "Brilliant Yellow",
      "type": "Yellow"
    },
    {
      "color": "Naples Yellow Deep",
      "type": "Yellow"
    },
    {
      "color": "Yellow Ochre Light",
      "type": "Yellow"
    },
    {
      "color": "Yellow Ochre Pale",
      "type": "Yellow"
    },
    {
      "color": "Indian Yellow Deep",
      "type": "Yellow"
    },
    {
      "color": "Gold Ochre",
      "type": "Yellow"
    },
    {
      "color": "Yellow Ochre",
      "type": "Yellow"
    },
    {
      "color": "Raw Umber Light",
      "type": "Brown"
    },
    {
      "color": "Raw Sienna",
      "type": "Brown"
    },
    {
      "color": "Transparent Gold Ochre",
      "type": "Brown"
    },
    {
      "color": "Brown Ochre",
      "type": "Brown"
    },
    {
      "color": "Burnt Sienna",
      "type": "Brown"
    },
    {
      "color": "Transparent Red Ochre",
      "type": "Brown"
    },
    {
      "color": "Light Red",
      "type": "Brown"
    },
    {
      "color": "Venetian Red",
      "type": "Brown"
    },
    {
      "color": "Terra Rosa",
      "type": "Brown"
    },
    {
      "color": "Transparent Maroon",
      "type": "Brown"
    },
    {
      "color": "Indian Red",
      "type": "Brown"
    },
    {
      "color": "Mars Violet Deep",
      "type": "Brown"
    },
    {
      "color": "Warm Brown Pink",
      "type": "Brown"
    },
    {
      "color": "Brown Madder",
      "type": "Brown"
    },
    {
      "color": "Transparent Brown Ochre",
      "type": "Brown"
    },
    {
      "color": "Burnt Umber",
      "type": "Brown"
    },
    {
      "color": "Vandyke Brown",
      "type": "Brown"
    },
    {
      "color": "Raw Umber",
      "type": "Brown"
    },
    {
      "color": "Raw Umber (Green Shade)",
      "type": "Brown"
    },
    {
      "color": "Davy's Gray",
      "type": "Grey"
    },
    {
      "color": "Payne's Gray",
      "type": "Grey"
    },
    {
      "color": "Blue Black",
      "type": "Grey"
    },
    {
      "color": "Indigo",
      "type": "Grey"
    },
    {
      "color": "Charcoal Grey",
      "type": "Grey"
    },
    {
      "color": "Mars Black",
      "type": "Black"
    },
    {
      "color": "Ivory Black",
      "type": "Black"
    },
    {
      "color": "Lamp Black",
      "type": "Black"
    },
    {
      "color": "Perylene Black",
      "type": "Black"
    },
    {
      "color": "Flake White",
      "type": "White"
    },
    {
      "color": "Zinc White",
      "type": "White"
    },
    {
      "color": "Underpainting White",
      "type": "White"
    },
    {
      "color": "Titanium White",
      "type": "White"
    },
    {
      "color": "Bronze",
      "type": "Metallics"
    },
    {
      "color": "Copper",
      "type": "Metallics"
    },
    {
      "color": "Renaissance Gold",
      "type": "Metallics"
    },
    {
      "color": "Gold",
      "type": "Metallics"
    },
    {
      "color": "Pewter",
      "type": "Metallics"
    },
    {
      "color": "Silver",
      "type": "Metallics"
    }
  ],
  "Daler-Rowney": [
    {
      "color": "Lemon Yellow",
      "type": "Yellow"
    },
    {
      "color": "Process Yellow",
      "type": "Yellow"
    },
    {
      "color": "Cadmium Yellow Hue",
      "type": "Yellow"
    },
    {
      "color": "Cadmium Yellow Deep Hue",
      "type": "Yellow"
    },
    {
      "color": "Cadmium Orange Light Hue",
      "type": "Orange"
    },
    {
      "color": "Cadmium Orange Hue",
      "type": "Orange"
    },
    {
      "color": "Cadmium Scarlet Hue",
      "type": "Red"
    },
    {
      "color": "Vermilion Hue",
      "type": "Red"
    },
    {
      "color": "Cadmium Red Hue",
      "type": "Red"
    },
    {
      "color": "Cadmium Red Deep Hue",
      "type": "Red"
    },
    {
      "color": "Crimson",
      "type": "Red"
    },
    {
      "color": "Process Magenta",
      "type": "Red"
    },
    {
      "color": "Purple",
      "type": "Purple"
    },
    {
      "color": "Velvet Purple",
      "type": "Purple"
    },
    {
      "color": "Deep Violet",
      "type": "Purple"
    },
    {
      "color": "Prussian Blue Hue",
      "type": "Blue"
    },
    {
      "color": "Phthalo Blue",
      "type": "Blue"
    },
    {
      "color": "Ultramarine",
      "type": "Blue"
    },
    {
      "color": "Cobalt Blue Hue",
      "type": "Blue"
    },
    {
      "color": "Process Cyan",
      "type": "Blue"
    },
    {
      "color": "Cerulean Blue Hue",
      "type": "Blue"
    },
    {
      "color": "Wedgewood",
      "type": "Blue"
    },
    {
      "color": "Phthalo Turquoise",
      "type": "Blue"
    },
    {
      "color": "Phthalo Green",
      "type": "Green"
    },
    {
      "color": "Emerald",
      "type": "Green"
    },
    {
      "color": "Leaf Green",
      "type": "Green"
    },
    {
      "color": "Pale Olive Green",
      "type": "Green"
    },
    {
      "color": "Sap Green",
      "type": "Green"
    },
    {
      "color": "Hooker's Green",
      "type": "Green"
    },
    {
      "color": "Oxide of Chromium Green",
      "type": "Green"
    },
    {
      "color": "Buff Titanium",
      "type": "Brown"
    },
    {
      "color": "Portrait Pink",
      "type": "Brown"
    },
    {
      "color": "Naples Yellow",
      "type": "Brown"
    },
    {
      "color": "Yellow Ochre",
      "type": "Brown"
    },
    {
      "color": "Raw Sienna",
      "type": "Brown"
    },
    {
      "color": "Burnt Sienna",
      "type": "Brown"
    },
    {
      "color": "Burnt Umber",
      "type": "Brown"
    },
    {
      "color": "Raw Umber",
      "type": "Brown"
    },
    {
      "color": "Warm Grey",
      "type": "Grey"
    },
    {
      "color": "Payne's Grey",
      "type": "Grey"
    },
    {
      "color": "Mars Black",
      "type": "Black"
    },
    {
      "color": "Process Black",
      "type": "Black"
    },
    {
      "color": "Zinc Mixing White",
      "type": "White"
    },
    {
      "color": "Titanium White",
      "type": "White"
    },
    {
      "color": "Silver Imit",
      "type": "Metallics"
    },
    {
      "color": "Pale Gold Imit",
      "type": "Metallics"
    },
    {
      "color": "Rich Gold Imit",
      "type": "Metallics"
    },
    {
      "color": "Copper Imit",
      "type": "Metallics"
    },
    {
      "color": "Fluorescent Yellow",
      "type": "Fluorescents"
    },
    {
      "color": "Fluorescent Orange",
      "type": "Fluorescents"
    },
    {
      "color": "Fluorescent Red",
      "type": "Fluorescents"
    },
    {
      "color": "Fluorescent Pink",
      "type": "Fluorescents"
    },
    {
      "color": "Fluorescent Blue",
      "type": "Fluorescents"
    },
    {
      "color": "Fluorescent Green",
      "type": "Fluorescents"
    }
  ]
};

class ColorSwatches extends HTMLElement {
  constructor() {
    super();

    this.products = [];
    this.variants = [];
    this.allVariants = {};
    this.optionsWithValues = {
      values: []
    };
    const productsJsonScriptElements = this.querySelectorAll('.ProductJSON');
    let productVendor = null;
    console.log('productsJsonScriptElements count', productsJsonScriptElements.length)
    // let colorOptionIndex = null;
    productsJsonScriptElements?.forEach(json => {
      const product = JSON.parse(json.innerHTML);
      productVendor = product.vendor;
      this.products.push(product);

      console.log('this.products count', this.products.length, product.title)

      const colorOptionIndex = product.options.findIndex(o => ['colour', 'color'].includes(o.toLowerCase()));
      console.log('colorOptionIndex', colorOptionIndex)
      if(colorOptionIndex !== null || colorOptionIndex !== -1) {
        for(let v = 0; v < product.variants.length; v++) {
          // colorOptionIndex
          const variant = product.variants[v];
          const color = variant[`option${colorOptionIndex + 1}`];
          if(!this.allVariants?.[color]) { this.allVariants[color] = []; }

          this.allVariants[color].push({
            ...variant,
            product_title: product.title,
            color_option_index: colorOptionIndex
          })
        }
        
      }

      const color_option = product.options_with_values[colorOptionIndex];
      const option_values = color_option?.values; 

      const all_option_values = [];
      for(let o = 0; o < option_values?.length; o++) {
        const option_value = option_values[o];
        if(this.optionsWithValues.values.findIndex(owv => owv.name === option_value.name) === -1) {
          all_option_values.push({...option_value});
        }
      }

      if(!this.optionsWithValues?.name) {
        delete color_option.values;
        this.optionsWithValues = {
          ...color_option,
          values: []
        }
      }
      this.optionsWithValues.values.push(...all_option_values)
    });
    const sortingArr = colorOrderList?.[productVendor];
    this.optionsWithValues.values.sort((a, b) => {
      if(sortingArr) {
        const indexA = sortingArr.findIndex(x => x.color.toLowerCase() === a.name.toLowerCase());
        const indexB = sortingArr.findIndex(y => y.color.toLowerCase() === b.name.toLowerCase());
  
        return indexA - indexB;
      } else {
        return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0);
      }
    });

    console.log('this.optionsWithValues', this.optionsWithValues);

    this.init();
    this.refreshGrid();
    window.addEventListener("resize", this.refreshGrid.bind(this));

    const chooseVariantButton = document.querySelector('.choose-variant');
    chooseVariantButton.addEventListener('click', () => {
      console.log('offset top', this.offsetTop);
      const modal = this.closest('.quick-add-modal__content');
      if (modal){
        modal.scroll(0, this.offsetTop - 20);
      }  else{
        window.scroll(0, this.offsetTop - 20);
      }
    })
  }

  init() {
    const colorSwatches = `
    <variant-selects id="${this.getAttribute('data-section-id')}" data-section="${this.getAttribute('data-section-id')}">
      <fieldset class="js product-form__input product-form__input--swatch">
        <legend class="form__label">
          <span class="form__label__label">Choose ${this.optionsWithValues.name}</span>
          <div class="variant-selects__colors-search-container">
            <div class="variant-selects__colors-search">
              <input placeholder="Search" type="search" />
              <span>
                <svg fill="none" class="icon icon-search" viewBox="0 0 18 19"><path fill="currentColor" fill-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 1 1 2.85 3.5a5.784 5.784 0 0 1 8.18 8.18m.26 1.12a6.78 6.78 0 1 1 .72-.7l5.4 5.4a.5.5 0 1 1-.71.7z" clip-rule="evenodd"></path></svg>
              </span>
            </div>
            <span class="form__label__count">(${this.optionsWithValues.values.length} ${this.optionsWithValues.name}s)</span> 
          </div>     
        </legend>
        <div class="swatch-inputs">${this.optionSwatchMarkup(this.optionsWithValues)}</div>
      </fieldset>
     </variant-selects>`;

     this.querySelector('.color___swatches').innerHTML = colorSwatches;
     this.initSearchEvent();
  }

  refreshGrid() {
    const elements = this.querySelectorAll('.swatch-input'); // or however you get the element
    const children = Array.from(elements);

    const rows = {};

    children.forEach(child => {
      const top = child.getBoundingClientRect().top;
      if (!rows[top]) rows[top] = [];
      rows[top].push(child);
    });

    const sortedRows = Object.keys(rows).sort((a, b) => a - b);

    elements.forEach(element => {
      const targetTop = element.getBoundingClientRect().top;
      const rowIndex = sortedRows.indexOf(String(targetTop));

      element.nextElementSibling.setAttribute('style', `--grid-row: ${rowIndex + 2};`);
    });
  }

  optionSwatchMarkup(option, search = null) {
    let swatchInputTemplate = this.querySelector('#SwatchInputTemplate')?.innerHTML;
    let swatchDetailsTemplate = this.querySelector('#SwatchDetailsTemplate')?.innerHTML;
    if(!swatchInputTemplate) return;

    let markup = "";
    const section_id = this.getAttribute('data-section-id');
    
    const name = `${ option.name }-${ option.position }`;
    const form_id = `product-form-${section_id}`;
    
    swatchInputTemplate = swatchInputTemplate.replaceAll('{name}', name);
    swatchInputTemplate = swatchInputTemplate.replaceAll('{product_form_id}', form_id);
    
    for(let v = 0; v < option.values.length; v++) {
      const value = option.values[v];
      if(search?.length && !value.name.toLowerCase().includes(search.toLowerCase())) continue; 
      const id = `${section_id}-${option.position}-${v}`;
      let optionMarkup = swatchInputTemplate;
      const optionAvailability = [];
      optionMarkup = optionMarkup.replaceAll('{id}', id);
      optionMarkup = optionMarkup.replaceAll('{value_id}', value.id);
      optionMarkup = optionMarkup.replaceAll('{value}', value.name);
      if(value?.swatch?.color?.rgba)
        optionMarkup = optionMarkup.replaceAll('{rgb}', `rgb(${value.swatch.color.rgba})`);

      let optionDetailMarkup = swatchDetailsTemplate;
      const variants = this.allVariants[value.name];
      let content = null;
      let product_content = null;
      let swatch_images = '';
      const size = [];
      console.log('color: ', value.name);

      for(let _v = 0; _v < variants.length; _v++) {
        const variant = variants[_v];
        const product = this.products.find(p => p.id === variant.product_id);
        console.log(
          'product: ',
          product?.title,
          'variant: ',
          variant?.title,
        );

        if(product && product?.metafields?.color_common_information && product_content === null) {
          product_content = product.metafields.color_common_information;
        }

        if(variant?.metafields?.variant_information && content === null) {
          content = product_content ?? "" + variant.metafields.variant_information;
        } else if (content === null && product_content !== null) {
          content = product_content ?? "";
        }

        optionAvailability.push(variant.available);

        const [opt, optMarkup] = this.sizeMarkup(variant);
        size.push({
          'key': opt,
          'value': optMarkup
        })

        if(variant?.metafields?.swatch_images && swatch_images.length === 0) {
          swatch_images += variant.metafields.swatch_images.map(url => `<img class="swatch-variant-image" src="${url}"/>`).join('');
        }
      }

      size.sort((a, b) => a.key.localeCompare(b.key, undefined,{ numeric: true }));

      // console.log(size)
      optionDetailMarkup = optionDetailMarkup.replaceAll('{rgb}', `rgb(${value?.swatch?.color?.rgba})`);
      optionDetailMarkup = optionDetailMarkup.replaceAll('{value}', value.name);
      optionDetailMarkup = optionDetailMarkup.replaceAll('{content_details}', content ?? "");
      optionDetailMarkup = optionDetailMarkup.replaceAll('{swatch_sizes}', size.map(s => s.value).join(''));
      optionDetailMarkup = optionDetailMarkup.replaceAll('{variant_images}', swatch_images);

      optionMarkup = optionMarkup.replaceAll('{radio_extra_attr}', optionAvailability.includes(true) ? '' : 'disabled');

      markup += optionMarkup;
      markup += optionDetailMarkup;
    }

    return markup;
  }

  sizeMarkup(variant) {
    let swatchSizeTemplate = this.querySelector('#SwatchSizeTemplate')?.innerHTML;
    if(!swatchSizeTemplate) return;
    let opt = null;

    if(variant.options.length === 1) {
      opt = variant.product_title.split('-').pop().trim();
      swatchSizeTemplate = swatchSizeTemplate.replaceAll('{size}', opt);
    } else {
      const product = this.products.find(p => p.id === variant.product_id);
      const colorOptionIndex = product.options.findIndex(o => ['colour', 'color'].includes(o.toLowerCase()));
      const options = variant.options.filter((o, index) => index !== colorOptionIndex);
      opt = options.join(' / ');
      swatchSizeTemplate = swatchSizeTemplate.replaceAll('{size}', opt);
    }

    const price = `
      ${
        variant?.compare_at_price && variant.compare_at_price > variant.price ? `
        <span class="compare-at-price">${this.formatCurrency(variant.compare_at_price)}</span>
        ` : `` 
      }
      
      <span class="sale-price">${this.formatCurrency(variant.price)}</span>
    `;
    swatchSizeTemplate = swatchSizeTemplate.replaceAll('{sku}', variant.sku);
    swatchSizeTemplate = swatchSizeTemplate.replaceAll('{price}', price);
    swatchSizeTemplate = swatchSizeTemplate.replaceAll('{variant_id}', variant.id);
    swatchSizeTemplate = swatchSizeTemplate.replaceAll('{atc_form_id}', `product-form-${variant.id}`);
    swatchSizeTemplate = swatchSizeTemplate.replaceAll('{state}', `${variant.available ? 'active' : 'disabled'}`);
    
    console.log('========================================');
    console.log(opt);
    console.log('========================================');
    return [opt, swatchSizeTemplate];
  }

  initSearchEvent() {
    const searchInput = this.querySelector('.variant-selects__colors-search input[type="search"]');
    searchInput.addEventListener('input', () => {
      console.log('input...', searchInput.value);
      const markup = this.optionSwatchMarkup(this.optionsWithValues, searchInput.value);
      console.log(markup.length, markup)
      this.querySelector('.swatch-inputs').innerHTML = markup?.length === 0 ? 'No colors found.' : markup;
      this.refreshGrid();
    });
  }

  formatCurrency(price) {
    return `${window.accessibilityStrings.currency}${(price / 100).toFixed(2)}`
  }
}

customElements.define('color-swatches', ColorSwatches);

class ColorSwatch extends HTMLElement {
  constructor() {
    super();

    this.detailContainer = this.nextElementSibling;
    this.swatchInputRadio = this.querySelector('input[type="radio"]');
    this.closeButton = this.detailContainer.querySelector('.swatch-color-dropdown__close');

    this.initEvents();
  }

  initEvents() {
    this.swatchInputRadio.addEventListener('click', this.expand.bind(this));
    this.closeButton.addEventListener('click', this.collapse.bind(this));
  }

  expand() {
    const colorSwatches = [...this.closest('color-swatches').querySelectorAll('color-swatch')].filter(child => child !== this);

    for(const cs of colorSwatches) {
      cs.collapse();
    }

    this.detailContainer.classList.remove('hidden');
  }

  collapse(e) {
    if(e?.preventDefault)
      e.preventDefault();
    this.detailContainer.classList.add('hidden');

    if(this.swatchInputRadio && this.swatchInputRadio.checked) {
      this.swatchInputRadio.checked = false;
    }
  }
}

customElements.define('color-swatch', ColorSwatch);

